// Application errors.
export class APIError extends Error {
	constructor(path, errorMessage) {
		super(errorMessage);

		this.name = `APIError - ${path}`;
	}
}

// Authentication issues.
export class AuthError extends Error {
	static isAuthError(errorMessage) {
		return errorMessage.indexOf("invalid access token") >= 0
				|| errorMessage.indexOf("no_guest_id") >= 0
				|| errorMessage.indexOf("access_token") >= 0;
	}

	constructor(errorMessage) {
		super(errorMessage);

		this.name = `AuthError - ${errorMessage}`;
	}
}

// Connection issues.
export class NetworkError extends Error {
	static isNetworkError(errorMessage) {
		return errorMessage.indexOf("NetworkError") >= 0
				|| errorMessage.indexOf("The network connection was lost.") >= 0;
	}

	constructor(errorMessage) {
		super(errorMessage);

		this.name = "NetworkError";
	}
}



// WEBPACK FOOTER //
// ./src/shared/util/OkcApi/error.js